<template>
  <v-data-table
    :headers="headers"
    :items="processCheckSheets"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="ProcessCheckSheet-button-new"
          @click="$router.push({
            name: 'processing-EditProcessCheckSheet'
          })"
        >
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        :data-cy="`button-ProcessCheckSheet-edit-${item.id}`"
        @click="$router.push({
          name: 'processing-EditProcessCheckSheet',
          query: {id: item.id}
        })"
      >
        {{ mdiPencil }}
      </v-icon>
      <v-icon
        small
        @click="remove(item)"
        color="danger"
        :data-cy="`button-ProcessCheckSheet-remove-${item.id}`"
      >
        {{ mdiDelete }}
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPencil, mdiDelete } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListProcessCheckSheet',
  module: 'ProcessCheckSheet',
  mixins: [loading],
  data() {
    return {
      mdiPencil, mdiDelete,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('processCheckSheets', ['processCheckSheets']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('deliveryDate'),
          value: 'deliveryDate',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_processCheckSheets();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('processCheckSheets', ['LOAD_processCheckSheets', 'DELETE_processCheckSheet']),
    /** Delete ProcessCheckSheet from the collection
     */
    async remove(ProcessCheckSheet) {
      this.isLoading = true;
      await this.DELETE_processCheckSheet(ProcessCheckSheet);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# ProcessCheckSheet example

'''js
<ProcessCheckSheet />
'''
</docs>
